module.exports = __webpack_public_path__ + "static/media/visa-active.4a3f2567.svg";